import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { ScreensQuestionResource } from '@Components/mras/core';
import { SharedModule } from '@Shared/shared.module';

@Component({
    selector: 'jhi-numeric-input',
    templateUrl: './numeric-input.component.html',
    imports: [SharedModule]
})
export class NumericInputComponent implements OnInit, OnChanges {
    @Input() question: ScreensQuestionResource;
    @Input()
        value: string;
    @Output()
        valueChange = new EventEmitter<string>();
    @Output()
        action = new EventEmitter();

    @Input()
        summaryMode: boolean;

    @Input()
        name: string;
    @Input()
        min: number | null;
    @Input()
        max: number | null;
    @Input()
        placeholder: string;
    @Input()
        disabled: boolean;
    @Input()
        enableChangeButton: boolean;

    numericValue: number;
    validValue = true;

    ngOnInit(): void {
        if (this.min == null) {
            this.min = Number.MIN_VALUE;
        }
        if (this.max == null) {
            this.max = Number.MAX_VALUE;
        }
        this.numericValue = this.value == null || this.value === '' ? null : Number.parseFloat(this.value);
    }

    ngOnChanges(): void {
        this.numericValue = this.value == null || this.value === '' ? null : Number.parseInt(this.value);
    }

    onClick() {
        if (this.value && this.value !== '') {
            this.valueChange.emit(null);
        }

        this.value = null;
        if (this.numericValue != null) {
            this.value = this.numericValue.toString(10);
        }

        if (Number.isNaN(this.numericValue) || this.value === null || this.value === '')
        {
            this.question.invalid = true;
            this.validValue = false;

            this.valueChange.emit('');
            this.action.emit(null);
            return;
        }

        if (this.question.invalid) {
            this.question.invalid = false;
        }

        this.valueChange.emit(this.value);
        this.action.emit(null);
    }
}
